export const viveloTools = [
  {
    key: "crm",
    label: "Contactos / CRM",
    desc: "Gestiona tus prospectos",
    icon: "ri-contacts-book-2-line",
    to: "/app/contactos",
    color: "primary",
  },
  {
    key: "cursos",
    label: "Cursos",
    desc: "Aprende y entrena",
    icon: "ri-graduation-cap-line",
    to: "/app/cursos",
    color: "accent",
  },
  {
    key: "afiliado",
    label: "Panel de Afiliado",
    desc: "Tu link, QR y recompensas",
    icon: "ri-team-line",
    to: "/app/afiliado",
    color: "secondary",
  },
  {
    key: "comunidad",
    label: "Comunidad",
    desc: "Comparte con tu equipo",
    icon: "ri-community-line",
    to: "/app/comunidad",
    color: "primary",
  },
  {
    key: "retos",
    label: "Retos",
    desc: "Metas y ranking",
    icon: "ri-trophy-line",
    to: "/app/retos",
    color: "accent",
  },
  {
    key: "reuniones",
    label: "Reuniones",
    desc: "Próximas sesiones",
    icon: "ri-calendar-event-line",
    to: "/app/reuniones",
    color: "secondary",
  },
  {
    key: "progreso",
    label: "Mi progreso",
    desc: "Revisa tu avance",
    icon: "ri-line-chart-line",
    to: "/app/perfil",
    color: "primary",
  },
];